/**
 * Factory for the typed React-Query tRPC instance (P2-21).
 *
 * Wrapping `createTRPCReact` keeps the public surface single-entry — apps
 * never import directly from `@trpc/react-query`, so swapping the underlying
 * library in a future ADR (eg. tRPC v12 if its hook API changes) becomes a
 * one-file diff.
 */
import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import type { AnyTRPCRouter } from '@trpc/server';

/**
 * Reusable alias — `PosTrpcReact<AppRouter>` is the type apps need to type
 * their `trpc.Provider`, `useUtils()`, and per-procedure hooks against.
 */
export type PosTrpcReact<TRouter extends AnyTRPCRouter> = CreateTRPCReact<TRouter, unknown>;

/**
 * Create a typed React-Query tRPC instance for a given `AppRouter`.
 *
 *     import type { AppRouter } from '@mangrove/api';
 *     export const trpc = createPosTrpcReact<AppRouter>();
 */
export function createPosTrpcReact<TRouter extends AnyTRPCRouter>(): PosTrpcReact<TRouter> {
  return createTRPCReact<TRouter>();
}
